export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5329.e04807a1.jpg";